"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainPipeLinker_Warehouse_b = void 0;
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const pipeNode_1 = require("./pipeNode");
const pipeNodeGroup_1 = require("./pipeNodeGroup");
const boundingBox_1 = require("../boundingBox");
const nodeReverser_1 = require("./warehouse/nodeReverser");
const wallThroughHandler_b_1 = require("./wallThrough/wallThroughHandler_b");
const linkUtil_1 = require("./util/linkUtil");
const overlappedMainPipeHandler_1 = require("./overlap/overlappedMainPipeHandler");
//增加穿墙判断的连接方法
class MainPipeLinker_Warehouse_b {
    constructor(coordinateUtil, polygonSegs, polygonSegs_shellAndLargeHoles, mainPipes, mainPipesInRoom, mainPipeNodes) {
        this._coordinateUtil = coordinateUtil;
        this._polygonSegs = polygonSegs;
        this._wallThroughHandler = new wallThroughHandler_b_1.WallThroughHandler_b(polygonSegs_shellAndLargeHoles, coordinateUtil, mainPipes, mainPipesInRoom, mainPipeNodes);
        this._mainPipeNodes = mainPipeNodes;
    }
    linkV3(pipeNodeGroups, mainPipes, mainPipesInRoom, blankDis, originMainPipes) {
        //合并一些没有主节点的邻近点组
        this.mergeNoMainNodeGroups(pipeNodeGroups, blankDis, mainPipesInRoom);
        let pipeNodeGroups_linkToOtherGroup = new Array();
        for (let i = 0; i < pipeNodeGroups.length; i++) {
            let mainNode;
            let pipeNodeGroup = pipeNodeGroups[i];
            if (pipeNodeGroup._mainPipeNodes.length == 0) { //整个组只有一个子节点的情况，用这个子节点来充当主节点进行连接
                mainNode = pipeNodeGroup._childPipeNodes[0];
            }
            else {
                mainNode = pipeNodeGroup._mainPipeNodes[0];
            }
            //1.计算距离主节点最近的组
            let minDis_otherGroup = Number.POSITIVE_INFINITY;
            let closestGroup;
            for (let j = 0; j < pipeNodeGroups.length; j++) {
                if (i == j)
                    continue;
                //每组都只有一个主节点
                let otherGroup = pipeNodeGroups[j];
                let dis = otherGroup.getMinDis(mainNode);
                if (dis < minDis_otherGroup) {
                    minDis_otherGroup = dis;
                    closestGroup = otherGroup;
                }
            }
            let minDis_mainPipe = Number.POSITIVE_INFINITY;
            let closestMainPipe;
            let closestPoint;
            for (let mainPipe of mainPipesInRoom) {
                let point = mainPipe.closestPoint(mainNode._point);
                let dis = point.distance(mainNode._point);
                if (dis < minDis_mainPipe) {
                    minDis_mainPipe = dis;
                    closestMainPipe = mainPipe;
                    closestPoint = point;
                }
            }
            //3.判断哪个更近
            if (minDis_otherGroup <= minDis_mainPipe && this.calculateTheActualDistanceToOtherGroups(mainNode, closestGroup) < minDis_mainPipe) {
                pipeNodeGroups_linkToOtherGroup.push([pipeNodeGroup, closestMainPipe]);
            }
            else {
                this.linkToMainPipe(mainNode, closestPoint, closestMainPipe, minDis_mainPipe, mainPipes, pipeNodeGroup, pipeNodeGroups, true, mainPipesInRoom);
            }
        }
        this.handleGroupsWhichLinkToOtherGroup(pipeNodeGroups, pipeNodeGroups_linkToOtherGroup);
        //处理孤岛
        this.handleIsolatedIslands(this._mainPipeNodes[0].getRootNode(), pipeNodeGroups, mainPipes, mainPipesInRoom, originMainPipes);
        /*//加了穿墙判断后出现了不少重叠的主管线，这里统一判断并处理一下
        new OverlappedMainPipeHandler().handle(pipeNodeGroups, mainPipeNodes);*/
    }
    handleGroupsWhichLinkToOtherGroup(pipeNodeGroups, pipeNodeGroups_linkToOtherGroup) {
        const DistanceThreshold = 200; //由于相邻管点之间的距离有调整过，所以加个阈值
        for (let pair of pipeNodeGroups_linkToOtherGroup) {
            let pipeNodeGroup = pair[0];
            //判断是否在循环的过程中被移除了
            if (pipeNodeGroups.indexOf(pipeNodeGroup) < 0) {
                continue;
            }
            let closestMainPipe = pair[1];
            let mainNode;
            if (pipeNodeGroup._mainPipeNodes.length > 0)
                mainNode = pipeNodeGroup._mainPipeNodes[0];
            else
                mainNode = pipeNodeGroup._childPipeNodes[0];
            //有些组已经在穿墙判断时被移除空了，这里跳过
            if (!mainNode)
                continue;
            let pairs_toOtherGroup = new Array();
            let index = pipeNodeGroups.indexOf(pipeNodeGroup);
            for (let i = 0; i < pipeNodeGroups.length; i++) {
                if (i == index)
                    continue;
                let otherGroup = pipeNodeGroups[i];
                if (otherGroup._mainPipeNodes.length == 0) //没有主节点的不能被别的组连接
                    continue;
                //跳过原本有父子关系的组
                if (this.hasParentChildRelationship(mainNode, otherGroup._mainPipeNodes[0]) || this.hasParentChildRelationship(otherGroup._mainPipeNodes[0], mainNode)) {
                    continue;
                }
                let dis = otherGroup.getMinDis(mainNode);
                pairs_toOtherGroup.push([dis, otherGroup]);
            }
            if (pairs_toOtherGroup.length == 0)
                continue;
            pairs_toOtherGroup.sort(function (a, b) { return a[0] - b[0]; });
            let minDis = pairs_toOtherGroup[0][0];
            let nearestPipeNodeGroups = new Array();
            for (let pair of pairs_toOtherGroup) {
                if (pair[0] - minDis < DistanceThreshold)
                    nearestPipeNodeGroups.push(pair[1]);
            }
            let minDisToMainPipe = Number.POSITIVE_INFINITY;
            let nearestPipeNodeGroup = undefined;
            for (let group of nearestPipeNodeGroups) {
                let dis = closestMainPipe.distance(group._mainPipeNodes[0]._point);
                if (dis < minDisToMainPipe) {
                    minDisToMainPipe = dis;
                    nearestPipeNodeGroup = group;
                }
            }
            //异常情况，跳过
            if (nearestPipeNodeGroup === undefined) {
                debugger;
                continue;
            }
            //TODO：这里判断可能有些问题，||后面的是不是需要加个容差
            if (pipeNodeGroup._mainPipeNodes.length == 0 || minDisToMainPipe < closestMainPipe.distance(mainNode._point)) {
                if (mainNode._parent) { //避免有些节点被反复添加
                    continue;
                }
                this.linkToOtherGroup(nearestPipeNodeGroup._mainPipeNodes[0], mainNode, nearestPipeNodeGroup, pipeNodeGroup, pipeNodeGroups);
            }
            else {
                if (nearestPipeNodeGroup._mainPipeNodes[0]._parent) {
                    continue;
                }
                this.linkToOtherGroup(mainNode, nearestPipeNodeGroup._mainPipeNodes[0], pipeNodeGroup, nearestPipeNodeGroup, pipeNodeGroups);
            }
        }
    }
    getIsolatedIslandMainNodes(rootNode, pipeNodeGroups) {
        let notIsolatedGroups = new Array();
        let isolatedGroups = new Array();
        for (let pipeNodeGroup of pipeNodeGroups) {
            if (pipeNodeGroup._childPipeNodes.length == 0) //有些组已经被切割掉所有喷头了，这里需要跳过这些组
                continue;
            if (pipeNodeGroup._childPipeNodes[0].getRootNode() == rootNode)
                notIsolatedGroups.push(pipeNodeGroup);
            else
                isolatedGroups.push(pipeNodeGroup);
        }
        //取出孤岛里的根节点（因为有些孤岛点组已经连到别的了）
        let isolatedMainNodes = new Array();
        for (let pipeNodeGroup of isolatedGroups) {
            let mainNode = pipeNodeGroup._childPipeNodes[0].getRootNode();
            if (isolatedMainNodes.indexOf(mainNode) < 0)
                isolatedMainNodes.push(mainNode);
        }
        return isolatedMainNodes;
    }
    handleIsolatedIslands(rootNode, pipeNodeGroups, mainPipes, mainPipesInRoom, originMainPipes) {
        let isolatedMainNodes = this.getIsolatedIslandMainNodes(rootNode, pipeNodeGroups);
        if (isolatedMainNodes.length == 0)
            return;
        //判断是否需要翻转孤岛组的主节点顺序
        new nodeReverser_1.NodeReverser().executeForWarehouse(isolatedMainNodes, originMainPipes);
        for (let i = isolatedMainNodes.length - 1; i >= 0; i--) {
            let mainNode = isolatedMainNodes[i];
            this.handleOneIsolatedIsland(mainNode, pipeNodeGroups, mainPipes, mainPipesInRoom, this._mainPipeNodes, true);
            isolatedMainNodes.splice(i, 1);
        }
        isolatedMainNodes = this.getIsolatedIslandMainNodes(rootNode, pipeNodeGroups);
        if (isolatedMainNodes.length == 0)
            return;
        this._wallThroughHandler._allowBecomeIsolatedIsland = false;
        //判断是否需要翻转孤岛组的主节点顺序
        new nodeReverser_1.NodeReverser().executeForWarehouse(isolatedMainNodes, originMainPipes);
        //处理遗漏的孤岛，不允许连接到其他孤岛
        for (let i = isolatedMainNodes.length - 1; i >= 0; i--) {
            let mainNode = isolatedMainNodes[i];
            this.handleOneIsolatedIsland(mainNode, pipeNodeGroups, mainPipes, mainPipesInRoom, this._mainPipeNodes, false);
        }
    }
    handleOneIsolatedIsland(mainNode, pipeNodeGroups, mainPipes, mainPipesInRoom, mainPipeNodes, allowLinkToIsolatedIsland) {
        let pipeNodeGroup = this.findPipeNodeGroupByMainNode(mainNode, pipeNodeGroups);
        if (pipeNodeGroup._childPipeNodes.length == 0) {
            //异常情况
            return;
        }
        let minDis_mainPipe = Number.POSITIVE_INFINITY;
        let cloestMainPipe;
        let cloestPoint;
        for (let mainPipe of mainPipesInRoom) {
            let point = mainPipe.closestPoint(mainNode._point);
            let dis = point.distance(mainNode._point);
            if (dis < minDis_mainPipe) {
                minDis_mainPipe = dis;
                cloestMainPipe = mainPipe;
                cloestPoint = point;
            }
        }
        //这里要做的事情有两点
        //一是确定所有孤岛组连接完这一趟后不再有孤岛
        //二是需要优化孤岛组连接到主管线的方式，从最近的地方去连接，而不是简单从两头进行连接
        this.linkToMainPipe(mainNode, cloestPoint, cloestMainPipe, minDis_mainPipe, mainPipes, pipeNodeGroup, pipeNodeGroups, allowLinkToIsolatedIsland, mainPipesInRoom);
    }
    findPipeNodeGroupByMainNode(mainNode, pipeNodeGroups) {
        for (let group of pipeNodeGroups) {
            if (group._mainPipeNodes.indexOf(mainNode) > -1) {
                return group;
            }
        }
        //主管点里找不到就去对比childPipeNodes的第一个要素，mainNode有可能是这个要素（一般这种情况下该组是只有一个喷头的组）
        for (let group of pipeNodeGroups) {
            if (group._childPipeNodes[0] == mainNode) {
                return group;
            }
        }
        throw Error("没有找到对应的pipeNodeGroup");
    }
    linkToMainPipe(mainNode, closestPoint, closestMainPipe, minDis, mainPipes, pipeNodeGroup, pipeNodeGroups, allowLinkToIsolatedIsland, mainPipesInRoom) {
        //主节点在主干管上的情况
        if (minDis < 0.1) {
            if (closestPoint.equals2D(closestMainPipe.p0, 0.1)) {
                let node = this.findNode(closestMainPipe.p0, this._mainPipeNodes);
                node.addChildNode(mainNode);
            }
            else if (closestPoint.equals2D(closestMainPipe.p1, 0.1)) {
                let node = this.findNode(closestMainPipe.p1, this._mainPipeNodes);
                node.addChildNode(mainNode);
            }
            else { //在中间则需要增加节点
                let node_p0 = this.findNode(closestMainPipe.p0, this._mainPipeNodes);
                let node_p1 = this.findNode(closestMainPipe.p1, this._mainPipeNodes);
                let newLineSegment0 = new LineSegment_js_1.default(closestMainPipe.p0, mainNode._point);
                let newLineSegment1 = new LineSegment_js_1.default(closestMainPipe.p1, mainNode._point);
                mainPipes.splice(mainPipes.indexOf(closestMainPipe), 1);
                mainPipes.push(newLineSegment0);
                mainPipes.push(newLineSegment1);
                mainPipesInRoom.splice(mainPipesInRoom.indexOf(closestMainPipe), 1);
                mainPipesInRoom.push(newLineSegment0);
                mainPipesInRoom.push(newLineSegment1);
                this._mainPipeNodes.push(mainNode);
                if (node_p0._parent == node_p1) {
                    node_p1.removeChildNode(node_p0);
                    node_p1.addChildNode(mainNode);
                    mainNode.addChildNode(node_p0);
                }
                else if (node_p1._parent == node_p0) {
                    node_p0.removeChildNode(node_p1);
                    node_p0.addChildNode(mainNode);
                    mainNode.addChildNode(node_p1);
                }
                else {
                    //加一些额外措施，在多次连接中cloestMainPipe或许已被切为多段，所以这里需要进一步判断是否具有超过1级的父子关系
                    let deeperChildForP1 = pipeNode_1.PipeNode.findDeeperRelationshipNode(node_p0, node_p1);
                    if (deeperChildForP1) {
                        node_p1.removeChildNode(deeperChildForP1);
                        node_p1.addChildNode(mainNode);
                        mainNode.addChildNode(deeperChildForP1);
                        return;
                    }
                    let deeperChildForP0 = pipeNode_1.PipeNode.findDeeperRelationshipNode(node_p1, node_p0);
                    if (deeperChildForP0) {
                        node_p0.removeChildNode(deeperChildForP0);
                        node_p0.addChildNode(mainNode);
                        mainNode.addChildNode(deeperChildForP0);
                        return;
                    }
                    console.log(node_p0);
                    console.log(node_p1);
                    debugger;
                    console.error("不是父子关系");
                }
            }
        }
        else {
            //需要先判断投影的线会不会与自身的部分重叠。如果重叠，则需要进行延长
            let isLinkSegmentIntersectsWithSelf = false;
            //let projectionFactor = closestMainPipe.projectionFactor(mainNode._point);
            //let projectionPoint = closestMainPipe.pointAlong(projectionFactor);
            let projectResult = linkUtil_1.LinkUtil.computeProjectPointAndFactor(closestMainPipe, mainNode._point, this._coordinateUtil);
            let projectionFactor = projectResult.projectionFactor;
            let projectionPoint = projectResult.projectionPoint;
            let seg;
            if (pipeNodeGroup._mainPipeNodes.length > 0) {
                if (pipeNodeGroup._childPipeNodes.length == 1) { //组内只有单个喷头的情况
                    seg = new LineSegment_js_1.default(pipeNodeGroup._mainPipeNodes[0]._point, pipeNodeGroup._childPipeNodes[0]._point);
                }
                else {
                    seg = new LineSegment_js_1.default(pipeNodeGroup._childPipeNodes[0]._point, pipeNodeGroup._childPipeNodes[pipeNodeGroup._childPipeNodes.length - 1]._point);
                }
                let projectSeg = new LineSegment_js_1.default(mainNode._point, projectionPoint);
                if (projectSeg.distance(seg.p0) < 1 || projectSeg.distance(seg.p1) < 1) {
                    isLinkSegmentIntersectsWithSelf = true;
                }
            }
            let linkNode = mainNode;
            if (isLinkSegmentIntersectsWithSelf) { //连接到主干管的线如果与自身重叠，则需要进行延长
                //判断点组内部主节点数量是否大于1
                let secondMainNode;
                for (let child of mainNode._children) {
                    if (child._type == pipeNode_1.PipeNodeType.Main) {
                        secondMainNode = child;
                        break;
                    }
                }
                const expandDis = 600;
                let expandVec;
                if (secondMainNode) {
                    //延申600距离
                    expandVec = new Vector2D_js_1.default(secondMainNode._point, mainNode._point).normalize().multiply(expandDis);
                }
                else {
                    //只有一个主节点的情况，则需要取和子节点的垂直方向
                    let childNode = mainNode._children[0];
                    let vec_toChildNode = new Vector2D_js_1.default(mainNode._point, childNode._point);
                    let vec_toMainPipe = new Vector2D_js_1.default(mainNode._point, closestPoint);
                    //判断应该取垂直方向的哪一边
                    let angle = vec_toChildNode.angleTo(vec_toMainPipe);
                    if (angle > 0) {
                        expandVec = vec_toChildNode.rotate(Math.PI / 2).normalize().multiply(expandDis);
                    }
                    else {
                        expandVec = vec_toChildNode.rotate(-Math.PI / 2).normalize().multiply(expandDis);
                    }
                }
                let expandNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(mainNode._point.x + expandVec.getX(), mainNode._point.y + expandVec.getY()), pipeNode_1.PipeNodeType.Main);
                expandNode.addChildNode(mainNode);
                //连接到主管线
                /*projectionFactor = closestMainPipe.projectionFactor(expandNode._point);
                projectionPoint = closestMainPipe.pointAlong(projectionFactor);*/
                let projectResult = linkUtil_1.LinkUtil.computeProjectPointAndFactor(closestMainPipe, expandNode._point, this._coordinateUtil);
                projectionFactor = projectResult.projectionFactor;
                projectionPoint = projectResult.projectionPoint;
                linkNode = expandNode;
            }
            if (allowLinkToIsolatedIsland === false) {
                this.combineLinkNodeToClosestMainPipe(projectionFactor, projectionPoint, closestMainPipe, mainNode, linkNode, mainPipes, mainPipesInRoom, pipeNodeGroup, pipeNodeGroups, true);
            }
            else {
                //判断连接的线是否与其他组相交，相交的话则连接到这个组上
                let intersectPipeNodeGroup = this.computeIntersectPipeNodeGroup(linkNode, projectionPoint, projectionFactor, closestMainPipe, pipeNodeGroup, pipeNodeGroups);
                if (intersectPipeNodeGroup) {
                    this.linkToOtherGroup(intersectPipeNodeGroup._mainPipeNodes[0], linkNode, intersectPipeNodeGroup, pipeNodeGroup, pipeNodeGroups);
                }
                else {
                    this.combineLinkNodeToClosestMainPipe(projectionFactor, projectionPoint, closestMainPipe, mainNode, linkNode, mainPipes, mainPipesInRoom, pipeNodeGroup, pipeNodeGroups, false);
                }
            }
        }
    }
    combineLinkNodeToClosestMainPipe(projectionFactor, projectionPoint, closestMainPipe, mainNode, linkNode, mainPipes, mainPipesInRoom, currentPipeNodeGroup, pipeNodeGroups, isHandlingIsolatedIsland) {
        //判断投影点在不在原来的直线上
        if (projectionFactor == 0.0) {
            let node = this.findNode(closestMainPipe.p0, this._mainPipeNodes);
            node.addChildNode(linkNode);
            //判断一下linkNode到pipeNode的连线是否与其他管点重合
            new overlappedMainPipeHandler_1.OverlappedMainPipeHandler().handle(currentPipeNodeGroup, node, linkNode);
        }
        else if (projectionFactor == 1.0) {
            let node = this.findNode(closestMainPipe.p1, this._mainPipeNodes);
            node.addChildNode(linkNode);
            //判断一下linkNode到pipeNode的连线是否与其他管点重合
            new overlappedMainPipeHandler_1.OverlappedMainPipeHandler().handle(currentPipeNodeGroup, node, linkNode);
        }
        else if (projectionFactor < 0.0) {
            //判断是否延申到了房间外
            if (isHandlingIsolatedIsland || !this._wallThroughHandler.isOutside([new LineSegment_js_1.default(linkNode._point, projectionPoint)])) {
                let newMainPipe = new LineSegment_js_1.default(projectionPoint, closestMainPipe.p0);
                mainPipes.push(newMainPipe);
                mainPipesInRoom.push(newMainPipe);
                //新建节点
                let pipeNode = new pipeNode_1.PipeNode(projectionPoint, pipeNode_1.PipeNodeType.Main);
                let node_p0 = this.findNode(closestMainPipe.p0, this._mainPipeNodes);
                node_p0.addChildNode(pipeNode);
                pipeNode.addChildNode(linkNode);
                this._mainPipeNodes.push(pipeNode);
                //判断一下linkNode到pipeNode的连线是否与其他管点重合
                new overlappedMainPipeHandler_1.OverlappedMainPipeHandler().handle(currentPipeNodeGroup, pipeNode, linkNode);
            }
            else {
                //如果前面连接了mainNode和linkNode，则需要先解除关系
                if (mainNode._parent == linkNode) {
                    linkNode.removeChildNode(mainNode);
                }
                this._wallThroughHandler.linkToOtherGroupDirectly(mainNode, currentPipeNodeGroup, pipeNodeGroups);
            }
        }
        else if (projectionFactor > 1.0) {
            //判断是否延申到了房间外
            if (isHandlingIsolatedIsland || !this._wallThroughHandler.isOutside([new LineSegment_js_1.default(linkNode._point, projectionPoint)])) {
                let newMainPipe = new LineSegment_js_1.default(closestMainPipe.p1, projectionPoint);
                mainPipes.push(newMainPipe);
                mainPipesInRoom.push(newMainPipe);
                //新建节点
                let pipeNode = new pipeNode_1.PipeNode(projectionPoint, pipeNode_1.PipeNodeType.Main);
                let node_p1 = this.findNode(closestMainPipe.p1, this._mainPipeNodes);
                node_p1.addChildNode(pipeNode);
                pipeNode.addChildNode(linkNode);
                this._mainPipeNodes.push(pipeNode);
                //判断一下linkNode到pipeNode的连线是否与其他管点重合
                new overlappedMainPipeHandler_1.OverlappedMainPipeHandler().handle(currentPipeNodeGroup, pipeNode, linkNode);
            }
            else {
                //如果前面连接了mainNode和linkNode，则需要先解除关系
                if (mainNode._parent == linkNode) {
                    linkNode.removeChildNode(mainNode);
                }
                this._wallThroughHandler.linkToOtherGroupDirectly(mainNode, currentPipeNodeGroup, pipeNodeGroups);
            }
        }
        else { //在原来的线段中间
            let newMainPipes = [new LineSegment_js_1.default(closestMainPipe.p0, projectionPoint), new LineSegment_js_1.default(projectionPoint, closestMainPipe.p1)];
            //移除原来的线段
            mainPipes.splice(mainPipes.indexOf(closestMainPipe), 1);
            mainPipesInRoom.splice(mainPipesInRoom.indexOf(closestMainPipe), 1);
            //插入新的线段
            mainPipes.push(newMainPipes[0]);
            mainPipes.push(newMainPipes[1]);
            mainPipesInRoom.push(newMainPipes[0]);
            mainPipesInRoom.push(newMainPipes[1]);
            //判断p0和p1两个节点的父子关系
            let node_p0 = this.findNode(closestMainPipe.p0, this._mainPipeNodes);
            let node_p1 = this.findNode(closestMainPipe.p1, this._mainPipeNodes);
            let pipeNode = new pipeNode_1.PipeNode(projectionPoint, pipeNode_1.PipeNodeType.Main);
            this._mainPipeNodes.push(pipeNode);
            if (node_p1._parent == node_p0) {
                node_p0.removeChildNode(node_p1);
                //新建并插入节点
                node_p0.addChildNode(pipeNode);
                pipeNode.addChildNode(node_p1);
                pipeNode.addChildNode(linkNode);
                //判断一下linkNode到pipeNode的连线是否与其他管点重合
                new overlappedMainPipeHandler_1.OverlappedMainPipeHandler().handle(currentPipeNodeGroup, pipeNode, linkNode);
            }
            else if (node_p0._parent == node_p1) {
                node_p1.removeChildNode(node_p0);
                //新建并插入节点
                node_p1.addChildNode(pipeNode);
                pipeNode.addChildNode(node_p0);
                pipeNode.addChildNode(linkNode);
                //判断一下linkNode到pipeNode的连线是否与其他管点重合
                new overlappedMainPipeHandler_1.OverlappedMainPipeHandler().handle(currentPipeNodeGroup, pipeNode, linkNode);
            }
            else {
                //加一些额外措施，在多次连接中cloestMainPipe或许已被切为多段，所以这里需要进一步判断是否具有超过1级的父子关系
                let deeperChildForP1 = pipeNode_1.PipeNode.findDeeperRelationshipNode(node_p0, node_p1);
                if (deeperChildForP1) {
                    node_p1.removeChildNode(deeperChildForP1);
                    node_p1.addChildNode(pipeNode);
                    pipeNode.addChildNode(deeperChildForP1);
                    pipeNode.addChildNode(linkNode);
                    //判断一下linkNode到pipeNode的连线是否与其他管点重合
                    new overlappedMainPipeHandler_1.OverlappedMainPipeHandler().handle(currentPipeNodeGroup, pipeNode, linkNode);
                    return;
                }
                let deeperChildForP0 = pipeNode_1.PipeNode.findDeeperRelationshipNode(node_p1, node_p0);
                if (deeperChildForP0) {
                    node_p0.removeChildNode(deeperChildForP0);
                    node_p0.addChildNode(pipeNode);
                    pipeNode.addChildNode(deeperChildForP0);
                    pipeNode.addChildNode(linkNode);
                    //判断一下linkNode到pipeNode的连线是否与其他管点重合
                    new overlappedMainPipeHandler_1.OverlappedMainPipeHandler().handle(currentPipeNodeGroup, pipeNode, linkNode);
                    return;
                }
                console.log(node_p0);
                console.log(node_p1);
                debugger;
                throw new Error("p0和p1不是父子关系");
            }
        }
    }
    computeIntersectPipeNodeGroup(linkNode, projectionPoint, projectionFactor, closestMainPipe, pipeNodeGroup, pipeNodeGroups) {
        let linkSegments = [new LineSegment_js_1.default(linkNode._point, projectionPoint)];
        if (projectionFactor < 0) {
            linkSegments.push(new LineSegment_js_1.default(projectionPoint, closestMainPipe.p0));
        }
        else if (projectionFactor > 1) {
            linkSegments.push(new LineSegment_js_1.default(projectionPoint, closestMainPipe.p1));
        }
        let intersectGroups = new Array();
        let groupRootNode = pipeNodeGroup._childPipeNodes[0].getRootNode();
        //计算与投影点的连线与哪些点组的线段相交
        for (let pipeNodeGroup_other of pipeNodeGroups) {
            if (pipeNodeGroup_other == pipeNodeGroup)
                continue;
            if (pipeNodeGroup_other._childPipeNodes.length == 0)
                continue;
            //排除同一组的
            if (groupRootNode == pipeNodeGroup_other._childPipeNodes[0].getRootNode()) {
                continue;
            }
            let segments = pipeNodeGroup_other.getPipeSegments();
            for (let segment of segments) {
                let hasIntersectPoint = false;
                for (let linkSegment of linkSegments) {
                    let intersectPoint = linkSegment.intersection(segment);
                    if (intersectPoint) {
                        intersectGroups.push([pipeNodeGroup_other, linkNode._point.distance(intersectPoint)]);
                        hasIntersectPoint = true;
                        break;
                    }
                }
                if (hasIntersectPoint) {
                    break;
                }
            }
        }
        if (intersectGroups.length == 0)
            return null;
        //按距离排序，返回最近的点组
        intersectGroups.sort(function (a, b) { return a[1] - b[1]; });
        return intersectGroups[0][0];
    }
    findNode(point, nodes) {
        for (let node of nodes) {
            if (node._point.equals2D(point)) {
                return node;
            }
        }
        debugger;
        throw new Error("连接主管道时没有找到节点");
    }
    //连接两个管点。为了避免斜线的出现，在中间增加转折点
    linkToOtherGroup(node, child, parentPipeNodeGroup, currentPipeNodeGroup, pipeNodeGroups) {
        //转成当地坐标系
        this.transformNodesToLocal([node, child]);
        //按XY轴方向判断能否直接相连
        if (Math.abs(node._point.x - child._point.x) < 0.1 || Math.abs(node._point.y - child._point.y) < 0.1) {
            //检查是否与自身重叠
            if (!linkUtil_1.LinkUtil.linkSegmentOverlapWithPipe(node, child, this._coordinateUtil)) {
                node.addChildNode(child);
                //return前转回世界坐标
                this.transformNodesToWorld([node, child]);
            }
            else {
                let linkNode1;
                let linkNode2;
                if (Math.abs(node._point.x - child._point.x) < 0.1) {
                    linkNode1 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(node._point.x + 600, node._point.y), pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                    linkNode2 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(child._point.x + 600, child._point.y), pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                    node.addChildNode(linkNode1);
                    linkNode1.addChildNode(linkNode2);
                    linkNode2.addChildNode(child);
                }
                else {
                    linkNode1 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(node._point.x, node._point.y + 600), pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                    linkNode2 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(child._point.x, child._point.y + 600), pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                    node.addChildNode(linkNode1);
                    linkNode1.addChildNode(linkNode2);
                    linkNode2.addChildNode(child);
                }
                this.transformNodesToWorld([node, linkNode1, linkNode2, child]);
            }
        }
        else {
            //两种情况：一种是两条线平行，一种是垂直
            if (node._children.length == 0) { //异常情况，直接直角相连
                let linkNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(node._point.x, child._point.y), pipeNode_1.PipeNodeType.ChildLink, pipeNode_1.CoordSystem.Local);
                node.addChildNode(linkNode);
                linkNode.addChildNode(child);
                //return前转回世界坐标
                this.transformNodesToWorld([node, linkNode, child]);
                return;
            }
            let vec1 = this.getPipeVector(node);
            if (child._children.length == 0) { //子组只有单喷头的情况
                let center = new LineSegment_js_1.default(node._point, child._point).midPoint();
                let linkNode1;
                let linkNode2;
                if (Math.abs(vec1.getX()) > Math.abs(vec1.getY())) { //横向的平行
                    linkNode1 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(node._point.x, center.y), pipeNode_1.PipeNodeType.ChildLink, pipeNode_1.CoordSystem.Local);
                    linkNode2 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(child._point.x, center.y), pipeNode_1.PipeNodeType.ChildLink, pipeNode_1.CoordSystem.Local);
                }
                else { //竖向的平行
                    linkNode1 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(center.x, node._point.y), pipeNode_1.PipeNodeType.ChildLink, pipeNode_1.CoordSystem.Local);
                    linkNode2 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(center.x, child._point.y), pipeNode_1.PipeNodeType.ChildLink, pipeNode_1.CoordSystem.Local);
                }
                //TODO：这里判断是否穿墙
                if (!this._wallThroughHandler.isOutside([new LineSegment_js_1.default(node._point, linkNode1._point), new LineSegment_js_1.default(linkNode1._point, linkNode2._point), new LineSegment_js_1.default(linkNode2._point, child._point)])) {
                    this.transformNodesToWorld([node]);
                    this._wallThroughHandler.getNearestPartAndLinkOn(child, currentPipeNodeGroup, parentPipeNodeGroup, pipeNodeGroups);
                    this.transformNodesToLocal([node]);
                }
                else {
                    node.addChildNode(linkNode1);
                    linkNode1.addChildNode(linkNode2);
                    linkNode2.addChildNode(child);
                }
                //return前转回世界坐标
                this.transformNodesToWorld([node, linkNode1, linkNode2, child]);
                return;
            }
            let vec2 = this.getPipeVector(child);
            let angle = Math.abs(vec1.angleTo(vec2));
            if (angle < 5 / 180 * Math.PI || angle > 175 / 180 * Math.PI) { //平行的情况
                let center = new LineSegment_js_1.default(node._point, child._point).midPoint();
                let linkNode1;
                let linkNode2;
                if (Math.abs(vec1.getX()) > Math.abs(vec1.getY())) { //横向的平行
                    linkNode1 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(node._point.x, center.y), pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                    linkNode2 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(child._point.x, center.y), pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                }
                else { //竖向的平行
                    linkNode1 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(center.x, node._point.y), pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                    linkNode2 = new pipeNode_1.PipeNode(new Coordinate_js_1.default(center.x, child._point.y), pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                }
                //TODO：这里判断是否穿墙
                if (!this._wallThroughHandler.isOutside([new LineSegment_js_1.default(node._point, linkNode1._point), new LineSegment_js_1.default(linkNode1._point, linkNode2._point), new LineSegment_js_1.default(linkNode2._point, child._point)])) {
                    //这里的ToWorld和ToLocal都是临时措施。
                    //node节点在当前方法中有转Local和World的部分，而getNearestPartAndLinkOn方法内在parentPipeNodeGroup节点数组中分别转了Local和World，这里这样写是为了抵消一次转换，以得到正确结果，后续需要简化。
                    this.transformNodesToWorld([node]);
                    this._wallThroughHandler.getNearestPartAndLinkOn(child, currentPipeNodeGroup, parentPipeNodeGroup, pipeNodeGroups);
                    this.transformNodesToLocal([node]);
                }
                else {
                    node.addChildNode(linkNode1);
                    linkNode1.addChildNode(linkNode2);
                    linkNode2.addChildNode(child);
                }
                //return前转回世界坐标
                this.transformNodesToWorld([node, linkNode1, linkNode2, child]);
            }
            else { //一般为垂直的情况，其他情况应该也适用
                let seg1;
                let seg2;
                if (Math.abs(vec1.getX()) > Math.abs(vec1.getY())) { //vec1偏横向，则连接线为竖向
                    seg1 = new LineSegment_js_1.default(node._point, new Coordinate_js_1.default(node._point.x, node._point.y + 1));
                    seg2 = new LineSegment_js_1.default(child._point, new Coordinate_js_1.default(child._point.x + 1, child._point.y));
                }
                else {
                    seg1 = new LineSegment_js_1.default(node._point, new Coordinate_js_1.default(node._point.x + 1, node._point.y));
                    seg2 = new LineSegment_js_1.default(child._point, new Coordinate_js_1.default(child._point.x, child._point.y + 1));
                }
                let intersectPoint = seg1.lineIntersection(seg2);
                if (!intersectPoint) { //异常情况，直接直角相连
                    let linkNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(node._point.x, child._point.y), pipeNode_1.PipeNodeType.ChildLink, pipeNode_1.CoordSystem.Local);
                    node.addChildNode(linkNode);
                    linkNode.addChildNode(child);
                    //return前转回世界坐标
                    this.transformNodesToWorld([node, linkNode, child]);
                }
                else {
                    //TODO：这些linkNode可能也需要加进pipeNodeGroup内
                    let linkNode = new pipeNode_1.PipeNode(intersectPoint, pipeNode_1.PipeNodeType.Main, pipeNode_1.CoordSystem.Local);
                    //TODO：这里判断是否穿墙
                    if (!this._wallThroughHandler.isOutside([new LineSegment_js_1.default(node._point, linkNode._point), new LineSegment_js_1.default(linkNode._point, child._point)])) {
                        //这里的ToWorld和ToLocal都是临时措施。
                        //node节点在当前方法中有转Local和World的部分，而getNearestPartAndLinkOn方法内在parentPipeNodeGroup节点数组中分别转了Local和World，这里这样写是为了抵消一次转换，以得到正确结果，后续需要简化。
                        this.transformNodesToWorld([node]);
                        this._wallThroughHandler.getNearestPartAndLinkOn(child, currentPipeNodeGroup, parentPipeNodeGroup, pipeNodeGroups);
                        this.transformNodesToLocal([node]);
                    }
                    else {
                        node.addChildNode(linkNode);
                        linkNode.addChildNode(child);
                    }
                    //return前转回世界坐标
                    this.transformNodesToWorld([node, linkNode, child]);
                }
            }
        }
    }
    //检测是否能将一些没有主节点的邻近点组合并起来（没有主节点的点组，在合并前就是单独的一个喷头）
    mergeNoMainNodeGroups(pipeNodeGroups, blankDis, mainPipesInRoom) {
        let noMainNodeGroups = new Array();
        for (let group of pipeNodeGroups) {
            if (group._mainPipeNodes.length == 0)
                noMainNodeGroups.push(group);
        }
        //主要是合并Y方向上的单独管点组，所以按Y值排个序
        noMainNodeGroups.sort(function (a, b) { return a._childPipeNodes[0]._point.y - b._childPipeNodes[0]._point.y; });
        //分组
        let nearGroupsArr = new Array();
        for (let group of noMainNodeGroups) {
            let isNear = false;
            //判断是否与现有的某个组邻近
            for (let nearGroups of nearGroupsArr) {
                for (let other of nearGroups) {
                    let point0 = group._childPipeNodes[0]._point;
                    let point1 = other._childPipeNodes[0]._point;
                    //合并条件：
                    //1.距离符合条件。由于管点之间的距离有可能会被调整过，所以加个400的容差值。不过如果超过了blankDis*2，理论上来说是有问题的。
                    //2.合并后不穿过主管线
                    if (point0.distance(point1) < 2 * blankDis && this.isIntersectWithMainPipes(new LineSegment_js_1.default(point0, point1), mainPipesInRoom) === false) {
                        nearGroups.push(group);
                        isNear = true;
                        break;
                    }
                }
                if (isNear) {
                    break;
                }
            }
            nearGroupsArr.push([group]);
        }
        for (let nearGroups of nearGroupsArr) {
            if (nearGroups.length == 1)
                continue;
            //合并邻近的点
            let newGroup = new pipeNodeGroup_1.PipeNodeGroup([], []);
            for (let group of nearGroups) {
                newGroup._childPipeNodes.push(group._childPipeNodes[0]);
            }
            //计算主管点
            let boundingBox = new boundingBox_1.BoundingBox();
            for (let childNode of newGroup._childPipeNodes) {
                boundingBox.expand(childNode._point);
            }
            //只合并同一行或者同一列的
            if (boundingBox.getLengthX() > 1 || boundingBox.getLengthY() > 1) {
                continue;
            }
            //从旧的节点信息中移除
            for (let group of nearGroups) {
                pipeNodeGroups.splice(pipeNodeGroups.indexOf(group), 1);
            }
            let mainNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(boundingBox.getCenter().x, boundingBox.getCenter().y), pipeNode_1.PipeNodeType.Main);
            newGroup._mainPipeNodes.push(mainNode);
            //let overlapWithChildPoint = false;
            let overlappedChildPoint = undefined;
            for (let childNode of newGroup._childPipeNodes) {
                if (mainNode._point.equals2D(childNode._point, 200)) {
                    //overlapWithChildPoint = true;
                    overlappedChildPoint = childNode._point;
                    break;
                }
            }
            let frontNodes = new Array();
            let backNodes = new Array();
            if (overlappedChildPoint) {
                //mainNode._point.y += 600;
                mainNode._point = new Coordinate_js_1.default(overlappedChildPoint.x + 600, overlappedChildPoint.y);
            }
            for (let node of newGroup._childPipeNodes) {
                if (node._point.y < mainNode._point.y)
                    frontNodes.push(node);
                else
                    backNodes.push(node);
            }
            frontNodes.reverse();
            let previousNode = mainNode;
            for (let childNode of frontNodes) {
                previousNode.addChildNode(childNode);
                previousNode = childNode;
            }
            previousNode = mainNode;
            for (let childNode of backNodes) {
                previousNode.addChildNode(childNode);
                previousNode = childNode;
            }
            pipeNodeGroups.push(newGroup);
        }
    }
    //判断两个节点是否有父子或者同一树干的关系
    hasParentChildRelationship(child, parent) {
        let currentNode = child;
        while (currentNode._parent) {
            if (currentNode._parent == parent) {
                return true;
            }
            currentNode = currentNode._parent;
        }
        return false;
    }
    isIntersectWithMainPipes(segment, mainPipes) {
        for (let mainPipe of mainPipes) {
            if (segment.intersection(mainPipe)) {
                return true;
            }
        }
        return false;
    }
    //获取管道走向，用于判断两个管点组之间相连的走向
    getPipeVector(node) {
        for (let child of node._children) {
            if (child._type == pipeNode_1.PipeNodeType.Child || child._type == pipeNode_1.PipeNodeType.ChildLink) {
                return new Vector2D_js_1.default(node._point, this._coordinateUtil.transformPointToLocal(child._point));
            }
        }
        //意外情况，返回第一个点的向量
        return new Vector2D_js_1.default(node._point, this._coordinateUtil.transformPointToLocal(node._children[0]._point));
    }
    //计算连接到其他组所需的距离，如果太远了，则还是连接到主管道
    calculateTheActualDistanceToOtherGroups(mainNode, closestGroup) {
        let mainNodeOfOtherGroup;
        if (closestGroup._mainPipeNodes.length === 1) {
            mainNodeOfOtherGroup = closestGroup._mainPipeNodes[0];
        }
        else if (closestGroup._mainPipeNodes.length > 1) {
            let minDis = Number.POSITIVE_INFINITY;
            for (let node of closestGroup._mainPipeNodes) {
                let dis = mainNode._point.distance(node._point);
                if (dis < minDis) {
                    mainNodeOfOtherGroup = node;
                    minDis = dis;
                }
            }
        }
        else { //没有主节点算是意外情况，但是为了少做改动，没有主节点的情况就按最近的子节点来计算
            let minDis = Number.POSITIVE_INFINITY;
            for (let node of closestGroup._childPipeNodes) {
                let dis = mainNode._point.distance(node._point);
                if (dis < minDis) {
                    mainNodeOfOtherGroup = node;
                    minDis = dis;
                }
            }
        }
        //转到当地坐标系下，计算真正要连接时的距离（方方正正的折线）
        let p1 = this._coordinateUtil.transformPointToLocal(mainNode._point);
        let p2 = this._coordinateUtil.transformPointToLocal(mainNodeOfOtherGroup._point);
        return Math.abs(p1.x - p2.x) + Math.abs(p1.y - p2.y);
    }
    transformNodesToLocal(nodes) {
        for (let node of nodes) {
            if (node._coordSystem == pipeNode_1.CoordSystem.Local)
                continue;
            node._point = this._coordinateUtil.transformPointToLocal(node._point);
            node._coordSystem = pipeNode_1.CoordSystem.Local;
        }
    }
    transformNodesToWorld(nodes) {
        for (let node of nodes) {
            if (node._coordSystem == pipeNode_1.CoordSystem.World)
                continue;
            node._point = this._coordinateUtil.transformPointToWorld(node._point);
            node._coordSystem = pipeNode_1.CoordSystem.World;
        }
    }
}
exports.MainPipeLinker_Warehouse_b = MainPipeLinker_Warehouse_b;
